import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Navbar from './Navbar';
import DesktopBanner from './DesktopBanner';
import WebSectionButtons from './WebSectionButtons';
import WebStoreCTABox from './WebStoreCTABox';
import SingleBannerDesktop from './StoreSections/SingleBannerDesktop';
import CategorySectionDesktop from './StoreSections/CategorySectionDesktop';
import OfferDisplayDesktop from './StoreSections/OfferDisplayDesktop/OfferDisplayDesktop';
import CarouselBannerDesktop from './StoreSections/CarouselBannerDesktop/CarouselBannerDesktop';
import CategoryCollectionsListDesktop from './StoreSections/CategoryCollectionListDesktop/CategoryCollectionListDesktop';
import CustomCollectionListDesktop from './StoreSections/CustomCollectionListDesktop/CustomCollectionListDesktop';
import AboutOneDesktop from './AboutSections/AboutOneDesktop';
import AboutTwoDesktop from './AboutSections/AboutTwoDesktop';
import AboutThreeDesktop from './AboutSections/AboutThreeDesktop';
import FeaturesOneDesktop from './AboutSections/FeaturesOneDesktop';
import FeaturesTwoDesktop from './AboutSections/FeaturesTwoDesktop';

const OPTIONS = { loop: true, duration: 60, }

function DesktopScreen() {

    const zoomSize = useSelector((state) => state.storefront.zoomSize);
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);
    const pageType = useSelector((state) => state.storefront.pageType);

    const [screenSize, setScreenSize] = useState(0);

    useEffect(() => {
        setScreenSize((zoomSize/100)*800);
    }, [zoomSize]);

    return (
        <div style={{ width: `${screenSize}px` }} className='mx-auto mt-4 h-[calc(100%-32px)] border border-[#757575] overflow-y-scroll no-scrollbar'>
            <Navbar />

            <DesktopBanner />

            <div className="flex flex-col items-center gap-3">
                <WebSectionButtons />

                {
                    pageType === 'STORE' && 
                    <>
                        {versionStack[versionIndex]?.webVersionData?.map(item => {
                            if(item.item.typeData === 'CATEGORY') {
                                return (
                                    <CategorySectionDesktop 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'SINGLE_BANNER') {
                                return (
                                    <SingleBannerDesktop 
                                        item={item} 
                                        key={item.id} 
                                    />
                                );
                            }
                            if(item.item.typeData === 'CAROUSEL_BANNER') {
                                return (
                                    <CarouselBannerDesktop 
                                        item={item} 
                                        key={item.id} 
                                        options={OPTIONS} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'CATEGORY_COLLECTION_LIST') {
                                return (
                                    <CategoryCollectionsListDesktop 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'CUSTOM_COLLECTION_LIST') {
                                return (
                                    <CustomCollectionListDesktop 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            if(item.item.typeData === 'OFFER_DISPLAY') {
                                return (
                                    <OfferDisplayDesktop 
                                        item={item} 
                                        key={item.id} 
                                    />
                                )
                            }
                            else return null;
                        })}

                        <WebStoreCTABox />
                    </>
                }

                {
                    pageType === 'ABOUT' && 
                    <>
                        {versionStack[versionIndex]?.webStoreAbout.map(item => {
                            if(item.item.TypeData === 'ABOUT1') {
                                return (
                                    <AboutOneDesktop 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'ABOUT2') {
                                return (
                                    <AboutTwoDesktop 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'ABOUT3') {
                                return (
                                    <AboutThreeDesktop 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'FEATURE1') {
                                return (
                                    <FeaturesOneDesktop 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            if(item.item.TypeData === 'FEATURE2') {
                                return (
                                    <FeaturesTwoDesktop 
                                        key={item.id} 
                                        item={item} 
                                    />
                                );
                            }
                            else return null;
                        })}

                        <WebStoreCTABox />
                    </>
                }
            </div>
        </div>
    );
}

export default DesktopScreen;
